export default __webpack_public_path__ + "static/media/csv.b2e0c1c4.svg";